import './termSet.scss';

/* @ngInject */
export default function termSetController(FinancingFactory) {
    const vm = this;
    vm.today = '';

    vm.termSetSelected = function (termSet) {
        FinancingFactory.setSelectedRates(termSet.termSetData, vm.state.StateGeoId);
    };

    vm.rateAfterDiscount = function(rate, discountRate) {
        if (rate === null || rate === undefined ||
            discountRate === null || discountRate === undefined) {
            return null;
        }

        rate = parseFloat(rate);
        discountRate = parseFloat(discountRate);

        let r = rate - discountRate;
        r *= 100;
        r = Math.round(r);
        r /= 100;
        if (r <= 0) r = 0;
        return r;
    }

    vm.init = function () {
        vm.today = new Date(FinancingFactory.getCurrentDate());
        vm.today.setHours(0, 0, 0, 0);
    };
    vm.init();
}



// WEBPACK FOOTER //
// ./src/app/accounts/financing/termSetDirective/termSetController.js